import { booleanAttribute, Directive, ElementRef, HostBinding, Input, inject } from '@angular/core'

/**
 * Styles the element as an Input
 * Usable with Input Select TextArea
 */
@Directive({ selector: '[appInput]' })
export class InputDirective {
    private hostElement = inject(ElementRef)


    @Input()
    public variant: 'transparent' | 'default'

    @HostBinding('class.compact')
    @Input({ transform: booleanAttribute })
    public compact: boolean = false

    @HostBinding('class') get classes(): string {
        const element = this.hostElement.nativeElement as HTMLInputElement
        const elementTag = element.tagName.toLowerCase()
        const elementType = element.type

        const classes: Array<string> = []
        classes.push(`dir-${elementTag}`)
        if (this.variant === 'transparent') classes.push(`dir-${elementTag}--transparent`)
        if (elementType === 'search') classes.push(`dir-${elementTag}--search`)
        return classes.join(' ')
    }
}
